var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawingpencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_448",
    "data-name": "Group 448",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 44,
    height: 44,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "draw_FILL0_wght400_GRAD0_opsz40",
    d: "M19.132,30V27.673h1.146a6.549,6.549,0,0,0,3.264-.763q1.354-.764,1.354-1.771a1.757,1.757,0,0,0-.833-1.337,6.843,6.843,0,0,0-2.257-1.058l1.771-1.771a6.228,6.228,0,0,1,2.743,1.736,3.682,3.682,0,0,1,.9,2.431,3.972,3.972,0,0,1-2.136,3.593A9.24,9.24,0,0,1,20.278,30ZM8.507,19.653a5.526,5.526,0,0,1-2.656-1.476A3.049,3.049,0,0,1,5,16.111a3.182,3.182,0,0,1,.955-2.274,12.09,12.09,0,0,1,4.08-2.17,16.134,16.134,0,0,0,2.9-1.372A1.343,1.343,0,0,0,13.577,9.2a1.617,1.617,0,0,0-.747-1.32,3.809,3.809,0,0,0-2.274-.555,4.419,4.419,0,0,0-1.962.347,1.514,1.514,0,0,0-.816.764H5.1A4.171,4.171,0,0,1,6.892,6.007,6.25,6.25,0,0,1,10.556,5,6.128,6.128,0,0,1,14.41,6.128,3.677,3.677,0,0,1,15.868,9.2a3.36,3.36,0,0,1-.99,2.413,11.69,11.69,0,0,1-3.941,2.17,17.679,17.679,0,0,0-2.917,1.337,1.272,1.272,0,0,0-.694.989q0,.487.747.921a9.2,9.2,0,0,0,2.239.816ZM26.6,14.722,21.667,9.792l3.125-3.125L29.722,11.6ZM8.715,27.673h1.6L21.632,16.354l-1.6-1.6L8.715,26.077ZM6.389,30V25.069L20.035,11.423l4.93,4.931L11.319,30ZM20.035,14.757l1.6,1.6Z",
    transform: "translate(5 3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawingpencil);
export default __webpack_public_path__ + "static/media/drawingpencil.8f16384a6f748767bb232a84e92ee573.svg";
export { ForwardRef as ReactComponent };